/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiCreateContentMutationRequest, ContentAiCreateContentMutationResponse, ContentAiCreateContent401, ContentAiCreateContent403 } from "../models/ContentAiCreateContent";

export function getContentAiCreateContentUrl() {
  const res = { method: 'POST', url: `/content-ai/v1/contents` as const }
  return res
}

/**
 * @summary Create content
 * {@link /content-ai/v1/contents}
 */
export async function contentAiCreateContent(data: ContentAiCreateContentMutationRequest, config: Partial<RequestConfig<ContentAiCreateContentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ContentAiCreateContentMutationResponse, ResponseErrorConfig<ContentAiCreateContent401 | ContentAiCreateContent403>, ContentAiCreateContentMutationRequest>({ method : "POST", url : getContentAiCreateContentUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}